import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F57s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.GetMoveCombo = this.GetMoveCombo.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      no_inventario: "",
      descripcion: "",
      color: "",
      indetec: "",
      marca: "",
      modelo: "",
      serie: "",
      cve_emp: "",
      nombre: "",
      paterno: "",
      materno: "",
      area: "",
      observacion: "",
      estado_fisico: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: this.props.match.params.ambito_id,

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f57s: [], // Listado de elementos para la tabla
      loading: false,
      ambitos_desc: [],
      ambito_nivel: 0,
    };
  }

  componentDidMount = () => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Ambito/arbol/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      let ambitos_desc = res.data.desendientes.map((amb) => <option key={amb.id} value={amb.id}>
        {amb.dirgral} {amb.dir && " / " + amb.dir} {amb.depto && " / " + amb.depto}
      </option>);
      let ambito_nivel = res.data.ambito_nivel
      this.setState({ ambitos_desc: ambitos_desc, ambito_nivel: ambito_nivel })
      this.cargaTabla();
    });
  };

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F57/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f57s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/57/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      no_inventario: "",
      descripcion: "",
      color: "",
      indetec: "",
      marca: "",
      modelo: "",
      serie: "",
      cve_emp: "",
      nombre: "",
      paterno: "",
      materno: "",
      area: "",
      observacion: "",
      estado_fisico: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: this.props.match.params.ambito_id,
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      no_inventario: row.no_inventario,
      descripcion: row.descripcion,
      color: row.color,
      indetec: row.indetec,
      marca: row.marca,
      modelo: row.modelo,
      serie: row.serie,
      cve_emp: row.cve_emp,
      nombre: row.nombre,
      paterno: row.paterno,
      materno: row.materno,
      area: row.area,
      observacion: row.observacion,
      estado_fisico: row.estado_fisico,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      no_inventario: row.no_inventario,
      descripcion: row.descripcion,
      color: row.color,
      indetec: row.indetec,
      marca: row.marca,
      modelo: row.modelo,
      serie: row.serie,
      cve_emp: row.cve_emp,
      nombre: row.nombre,
      paterno: row.paterno,
      materno: row.materno,
      area: row.area,
      observacion: row.observacion,
      estado_fisico: row.estado_fisico,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      no_inventario: row.no_inventario,
      descripcion: row.descripcion,
      color: row.color,
      indetec: row.indetec,
      marca: row.marca,
      modelo: row.modelo,
      serie: row.serie,
      cve_emp: row.cve_emp,
      nombre: row.nombre,
      paterno: row.paterno,
      materno: row.materno,
      area: row.area,
      observacion: row.observacion,
      estado_fisico: row.estado_fisico,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      no_inventario: this.state.no_inventario,
      descripcion: this.state.descripcion,
      color: this.state.color,
      indetec: this.state.indetec,
      marca: this.state.marca,
      modelo: this.state.modelo,
      serie: this.state.serie,
      cve_emp: this.state.cve_emp,
      nombre: this.state.nombre,
      paterno: this.state.paterno,
      materno: this.state.materno,
      area: this.state.area,
      observacion: this.state.observacion,
      estado_fisico: this.state.estado_fisico,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .post("http://143.198.191.211/api/F57", data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      no_inventario: this.state.no_inventario,
      descripcion: this.state.descripcion,
      color: this.state.color,
      indetec: this.state.indetec,
      marca: this.state.marca,
      modelo: this.state.modelo,
      serie: this.state.serie,
      cve_emp: this.state.cve_emp,
      nombre: this.state.nombre,
      paterno: this.state.paterno,
      materno: this.state.materno,
      area: this.state.area,
      observacion: this.state.observacion,
      estado_fisico: this.state.estado_fisico,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.state.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put(
        "http://143.198.191.211/api/F57/" + this.state.id,
        data,
        config
      )
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F57/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeNoInventario = (e) => {
    this.setState({ no_inventario: e.target.value });
  };

  onChangeDescripcion = (e) => {
    this.setState({ descripcion: e.target.value });
  };

  onChangeColor = (e) => {
    this.setState({ color: e.target.value });
  };

  onChangeIndetec = (e) => {
    this.setState({ indetec: e.target.value });
  };

  onChangeMarca = (e) => {
    this.setState({ marca: e.target.value });
  };

  onChangeModelo = (e) => {
    this.setState({ modelo: e.target.value });
  };

  onChangeSerie = (e) => {
    this.setState({ serie: e.target.value });
  };

  onChangeCveEmp = (e) => {
    this.setState({ cve_emp: e.target.value });
  };

  onChangeNombre = (e) => {
    this.setState({ nombre: e.target.value });
  };

  onChangePaterno = (e) => {
    this.setState({ paterno: e.target.value });
  };

  onChangeMaterno = (e) => {
    this.setState({ materno: e.target.value });
  };

  onChangeArea = (e) => {
    this.setState({ area: e.target.value });
  };

  onChangeEstadoFisico = e => {
    this.setState({ estado_fisico: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = (e) => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = (e, row) => {
    row.usuario_id = localStorage.id
    row.ambito_id = e.target.value
    row.api_token = localStorage.api_token
    row.ambito_id_act = this.props.match.params.ambito_id
    let config = {};
    axios
      .put(
        "http://143.198.191.211/api/F57/" + row.id,
        row,
        config
      )
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"57"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={localStorage.permisos.includes("admin") ? false : true}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  GetMoveCombo = (cell, row) => {
    return (
      <Form.Control
        as="select"
        custom
        type="text"
        name="ambito_id"
        value={row.ambito_id}
        onChange={(e) => this.onChangeAmbitoId(e, row)}
      >
        {this.state.ambitos_desc}
      </Form.Control>
    );
  };

  render() {
    const columns = [
      {
        dataField: "",
        text: "Mover Bien A",
        formatter: this.GetMoveCombo,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "200px",
            zIndex: "99",
          };
        }
      },
      {
        dataField: "no_inventario",
        text: "No Inventario",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "descripcion",
        text: "Descripcion",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "color",
        text: "Color",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "indetec",
        text: "Indetec",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "marca",
        text: "Marca",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "modelo",
        text: "Modelo",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "serie",
        text: "Serie",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "cve_emp",
        text: "Cve Emp",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "nombre",
        text: "Nombre",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "paterno",
        text: "Paterno",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "materno",
        text: "Materno",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "area",
        text: "Area",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "estado_fisico",
        text: "Estado Físico",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ALIMENTOS Y UTENSILIOS</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 57 referente a
                alimentos y utensilios, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f57s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="57" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=57"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              {" "}
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No Inventario:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_inventario"
                  value={this.state.no_inventario}
                  onChange={this.onChangeNoInventario}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Descripcion:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="descripcion"
                  value={this.state.descripcion}
                  onChange={this.onChangeDescripcion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Color:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="color"
                  value={this.state.color}
                  onChange={this.onChangeColor}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Indetec:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="indetec"
                  value={this.state.indetec}
                  onChange={this.onChangeIndetec}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Marca:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip:
                            "Anotar la fecha, número de factura y costo de adquisición que ampara la adquisición del bien; mismo que debe coincidir con lo reflejado en la balanza de comprobación.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="marca"
                  value={this.state.marca}
                  onChange={this.onChangeMarca}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Modelo:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip:
                            "Anotar la fecha, número de factura y costo de adquisición que ampara la adquisición del bien; mismo que debe coincidir con lo reflejado en la balanza de comprobación.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="modelo"
                  value={this.state.modelo}
                  onChange={this.onChangeModelo}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Serie:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="serie"
                  value={this.state.serie}
                  onChange={this.onChangeSerie}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Cve Emp:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cve_emp"
                  value={this.state.cve_emp}
                  onChange={this.onChangeCveEmp}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={this.state.nombre}
                  onChange={this.onChangeNombre}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Paterno:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="paterno"
                  value={this.state.paterno}
                  onChange={this.onChangePaterno}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Materno:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="materno"
                  value={this.state.materno}
                  onChange={this.onChangeMaterno}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Area:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="area"
                  value={this.state.area}
                  onChange={this.onChangeArea}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estado Físico:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="estado_fisico"
                  value={this.state.estado_fisico}
                  onChange={this.onChangeEstadoFisico}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Comentarios que se consideren  pertinentes con respecto a la información señalada." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit} className="btn-ejecutar">
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No Inventario:
                    </Col>
                    <Col xs={10}>{this.state.no_inventario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Descripcion:
                    </Col>
                    <Col xs={10}>{this.state.descripcion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Color:
                    </Col>
                    <Col xs={10}>{this.state.color}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Indetec:
                    </Col>
                    <Col xs={10}>{this.state.indetec}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Marca:
                    </Col>
                    <Col xs={10}>{this.state.marca}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Modelo:
                    </Col>
                    <Col xs={10}>{this.state.modelo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Serie:
                    </Col>
                    <Col xs={10}>{this.state.serie}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Cve Emp:
                    </Col>
                    <Col xs={10}>{this.state.cve_emp}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre:
                    </Col>
                    <Col xs={10}>{this.state.nombre}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Paterno:
                    </Col>
                    <Col xs={10}>{this.state.paterno}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Materno:
                    </Col>
                    <Col xs={10}>{this.state.materno}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Area:
                    </Col>
                    <Col xs={10}>{this.state.area}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estado Fisico:
                    </Col>
                    <Col xs={10}>{this.state.estado_fisico}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>
                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F57s;
